module.exports = __webpack_public_path__ + "img/sld_mfm_inv_9_t1_b1_dark.4b56487d.svg";